import React, {Fragment, useEffect, useState, useRef} from 'react';
import {Card, Section, Date_picker, Text, Select, TextEditor, Popup, Accordion, Form, MultipleSelect} from '../../../../components';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import StageIcon from '@material-ui/icons/FilterNone';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {Field} from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import Grid from '@material-ui/core/Grid';
import MenuIcon from '@material-ui/icons/Menu'
import {connect} from 'react-redux';


function SalesCoachForm(props){
  const[setDealId, setSetDealId]=useState();
  const[error, setError]=useState({});
  let step_fields=useRef(undefined);
  const[total_weight, setTotalWeight]=useState(0);
  const[new_index, setNewIndex]=useState(0);
  let previous_weights=useRef({});
  let first_time=useRef(true);

  function onSubmit(params){
    if(props.deal_pipeline!=undefined){
      props.updateDealPipeline(params, props.deal_pipeline.id);
    }else{
      props.createDealPipeline(params);
    }
  }


  function moveCard(dragIndex, hoverIndex){
    let min_index=(dragIndex<=hoverIndex)?dragIndex:hoverIndex;
    let max_index=(hoverIndex>=dragIndex)?hoverIndex:dragIndex

    let new_fields=[];
    let index=0;
    for(let f of step_fields.current.input.value){
      if(index==min_index){new_fields.push(step_fields.current.input.value[max_index]);}
      if(index!=max_index){new_fields.push(f);}
      index+=1;
    }
    step_fields.current.input.onChange(JSON.parse(JSON.stringify(new_fields)));
  }

  let custom_fields=[];
  if(props.custom_deal_fields!=undefined){
    for(let key in props.custom_deal_fields){
      custom_fields.push(props.custom_deal_fields[key]);
    }
  }

  useEffect(()=>{
    if(props.quizzes_index!=true){props.indexQuizzes();}
    if(props.documents_index!=true){props.indexDocuments();}
    if(props.checklists_index!=true){props.indexChecklists();}
  },[]);

  let initial_values={}; if(props.deal_pipeline!=undefined){if(first_time.current==true){first_time.current=false; let new_total_weight=0; for(let qq of props.deal_pipeline.deal_stages){qq.weight=qq.weight/100; previous_weights.current[qq.id]=qq.weight; new_total_weight+=qq.weight;}; setTotalWeight(new_total_weight);}}

  let checklists_select=[]; if(props.checklists!=undefined){for(let key in props.checklists){checklists_select.push(props.checklists[key]);}}
  let documents_select=[]; if(props.documents!=undefined){for(let key in props.documents){documents_select.push(props.documents[key]);}}
  let quizzes_select=[]; if(props.quizzes!=undefined){for(let key in props.quizzes){quizzes_select.push(props.quizzes[key]);}}
  console.log(props.deal_pipeline);
  let initial_value=props.deal_pipeline; if(initial_value==undefined){initial_value={active:true}}else{for(let ds of initial_value.deal_stages){if(ds.documents!=undefined){let d_ids=[]; for(let d of ds.documents){d_ids.push(d.id);}; ds.document_ids=d_ids;};}}
  return(
    <Form
      onSubmit={onSubmit}
      initialValues={initial_value}
      mutators={{
        ...arrayMutators
      }}
      handleClose={props.handleClose}
      >
      {form_props => (
    <form autocomplete='off' onSubmit={form_props.handleSubmit}>
    <Popup always_open handleClose={props.handleClose} title={(props.deal_pipeline!=undefined)?'deal_pipeline_update_title':'deal_pipeline_create_title'} accept_button_click={()=>{form_props.form.submit();}} content={
      <div>
      <Grid container style={{marginTop:'20px', marginBottom:'20px', marginLeft:'20px', width:'calc(100% - 40px)', maxWidth:'1200px'}}>
      <Grid item xs={12} style={{marginBottom:'5px'}}><Text required title='Name' name={`name`}/></Grid>
      <Grid item xs={12} style={{marginBottom:'5px'}}><Text required multiline rows={3} title='Description' name={`description`}/></Grid>
      <Grid item xs={6} sm={4}><Select title='Quiz' name={`quizz_id`} select_data={quizzes_select}/></Grid>
      <Grid item xs={12}><Field name={`default`}>{(f)=>{return(<FormControlLabel control={<Checkbox style={{marginLeft:'10px'}} checked={f.input.value} onChange={f.input.onChange} name="pipeline" color="primary"/>} label="Default pipeline"/>)}}</Field></Grid>
      <Grid item xs={12} style={{marginBottom:'20px'}}><Field name={`active`}>{(f)=>{return(<FormControlLabel control={<Checkbox style={{marginLeft:'10px'}} checked={f.input.value} onChange={f.input.onChange} name="active" color="primary"/>} label="Active pipeline"/>)}}</Field></Grid>
      <Field name='deal_stages'>{(f)=>{step_fields.current=f; return null}}</Field>
      <Grid item xs={1}/><Grid item xs={10} style={{borderWidth:'1px', borderRadius:'5px', borderStyle:'solid'}}><FieldArray name={`deal_stages`}>
      {({ fields }) =>
        <Fragment>
        <Typography color='primary' style={{marginTop:'30px', marginBottom:'30px', position:'relative', width:'calc(100% - 40px)', marginLeft:'20px'}}><span><StageIcon color='primary' style={{position:'absolute', left:'0px'}}/></span><span style={{marginLeft:'40px'}}>Deal stages</span><AddIcon color='secondary' style={{position:'absolute', right:'20px', cursor:'pointer'}} onClick={()=>{fields.push({internal_id:'js_'+new_index, weight:(fields.value==undefined)?10:total_weight/fields.value.length, type:(fields.value==undefined || fields.value=='' || fields.value.length==0)?0:fields.value[fields.value.length-1].type}, undefined); setNewIndex(new_index+1)}}/></Typography>
        {fields.map((name, index) => {
          let card=fields.value[index];
          let id=fields.value[index].id;
          if(id==undefined){id=fields.value[index].internal_id;}
          return(
              <Card
                key={(card.id==undefined)?card.internal_id:card.id}
                index={index}
                id={(card.id==undefined)?card.internal_id:card.id}
                moveCard={moveCard}
                text={
            <Fragment>
            <hr style={{width:'100%', marginTop:'0px', marginBottom:'0px'}}/>
            <Accordion  content={[{title:<Field name={`${name}.name`}>{(f)=><Field name={`${name}.weight`}>{(fq)=><Typography style={{marginLeft:'10px', marginBottom:'10px', position:'relative', width:'calc(100% - 20px)'}} color='primary'><MenuIcon style={{position:'absolute', left:'-25px', cursor:'move', top:'3px', fontSize:'15px'}}/>{'Stage '+(index+1)+': '+f.input.value}<Typography style={{position:'absolute', right:'10px', top:'0px'}}>{Math.round((fq.input.value/total_weight)*10000)/100+'%'}</Typography><DeleteIcon color='secondary' style={{position:'absolute', right:'-10px', cursor:'pointer'}} onClick={()=>{fields.remove(index);setTotalWeight(total_weight - previous_weights.current[id]); e.stopPropagation()}}/></Typography>}</Field>}</Field>,
              content:<Grid container style={{marginBottom:'20px'}}>
                <Grid item xs={6} style={{marginBottom:'5px'}}><Text required title='Name' name={`${name}.name`}/></Grid>
                <Grid item xs={6}><Select title='Type' name={`${name}.type`} select_data={[{id:2, name:'Prospect'},{id:0, name:'Opportunity'},{id:1, name:'Deal'}]}/></Grid>
                <Grid item xs={6} style={{marginBottom:'5px'}}><Text required type='number' title='Weighting' name={`${name}.weight`}/></Grid>
                <Grid item xs={3} style={{marginBottom:'5px'}}><Field name={`${name}.weight`}>{(f)=>{let pv=(previous_weights.current[id]==undefined)?0:Number(previous_weights.current[id]); console.log(total_weight, f.input.value, pv); if(f.input.value!=pv){setTotalWeight(total_weight+Number(f.input.value) - pv); previous_weights.current[id]=f.input.value;}  return(<Typography style={{marginTop:'10px'}}>{Math.round((f.input.value/total_weight)*10000)/100+'%'}</Typography>)}}</Field></Grid>
                <Grid item xs={12} style={{marginBottom:'5px'}}><Text required multiline rows={3} title='Goal' name={`${name}.description`}/></Grid>
                <Grid item xs={12} style={{marginBottom:'5px'}}><Text required multiline rows={3} title='Customer value' name={`${name}.customer_value_description`}/></Grid>
                <Grid item xs={6} style={{marginBottom:'10px'}}sm={4}><Select title='Checklist' name={`${name}.checklist_id`} select_data={checklists_select}/></Grid>
                <Grid item xs={12} style={{marginBottom:'10px'}}><Field name={`${name}.document_ids`}>{(f)=><MultipleSelect title='Documents' select_data={documents_select} value={f.input.value} onChange={f.input.onChange} with_id/>}</Field></Grid>
                </Grid>
            }]}/>
            </Fragment>}/>
        )})}
        </Fragment>
      }</FieldArray></Grid>
      </Grid>
  </div>}  accept_button={'Save'}/>
      </form>
    )}</Form>
  );
}



export default connect(ss, dd)(SalesCoachForm);

function ss(state){
  return{
    quizzes:state.sales_coach.quizzes,
    refresh:state.sales_coach.refresh,
    quizzes_index:state.sales_coach.quizzes_index,
    documents:state.sales_coach.documents,
    documents_index:state.sales_coach.documents_index,
    checklists:state.sales_coach.checklists,
    checklists_index:state.sales_coach.checklists_index
  }
}

function dd(dispatch){
  return{
    indexDocuments:()=>{dispatch({type:'REQUEST_INDEX_DOCUMENTS'});},
    indexChecklists:()=>{dispatch({type:'REQUEST_INDEX_CHECKLISTS'});},
    indexQuizzes:()=>{dispatch({type:'REQUEST_INDEX_QUIZZES'});},
    createDealPipeline:(data)=>{dispatch({type:'REQUEST_CREATE_DEAL_PIPELINE', data:data})},
    updateDealPipeline:(data, id)=>{dispatch({type:'REQUEST_UPDATE_DEAL_PIPELINE', id:id, data:data})}
  }
}
